import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import EnhancedTable from '../../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../../widgets/Toolbar';
import { ViewContainer } from "../../../View";
import ViewUtils from "./../../../ViewUtils";

//CREATE NEW RE-USEABLE COMPONENT TO ALLOW FOR THE VIEWING OF UNIT STANDARDS FOR THE SELECT SCOPE
const utils = new ViewUtils();


//ID OF HEADCELLS TO MATCH THE SEARCH RESULT DTO NAME, TO BE DISPLAYED ON FRONT-END BUT THE TABLE ABSORBS ALL DATA COLUMN RETURNED FROM API
const headCells = [
    { id: 'SAQAUnitStandardID', numeric: false, disablePadding: true, label: 'Unitstandard Code' },
    { id: 'SAQAUnitStandardTitle', numeric: false, disablePadding: true, label: 'Unitstandard Title' }
];

const toolbarConfig = {
    items: [
        {

        }
    ]
};
class OnlineModeratorScopeUS  extends Component {

    state = {
        auditDialogOpen: false,
        selectedInterventionRecord: null
    }

    handleToolbarButtonClick(buttonId) {
    }

    handleToolbarButtonMenuClick(menu) {
       
    }

    postLinkHandler(linked) {
      
    }

    render() {
        return (
            <ViewContainer title="">
                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)}
                        config={toolbarConfig} />
                    <EnhancedTable
                        //USED FOR EXTERNAL CALLS
                        checkRefreshToken={!this.props.IsExternal}
                        headCells={headCells}
                        height="50vh"
                        //DETERMINES THE API BEING CALLED
                        dataUrl={utils.isNull(this.props.dataUrl) ? "" : this.props.dataUrl}
                        //BELOW ARE FILTERS PASSED TO THE CONTROLLER AND USED WITHIN THE STORED PROC 
                        searchParameters={[{ Name: "ID", Value: this.props.Id }, { Name: "IType", Value: this.props.ScopeType }]} paged={true} />
                    
                </div>

            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(OnlineModeratorScopeUS)
);
